import { TaskStatus } from "../../../../../../api/src/encode/encode-task.entity";

export class ExportDownloadUtils {
	static filterItemsByStatus(items: any[], status: TaskStatus) {
		return items.filter(item => item.encodeTasks.every(task => task.status === status))?.length > 0;
	}

	static findItemByStatus(items: any[], status: TaskStatus) {
		return items.find(item => item.encodeTasks.some(task => task.status === status));
	}

	static getGroupFormats(items: any[]) {
		return new Set(items.map(item => item.encodeTasks.map(task => task.metadata.formats).flat()).flat());
	}
}
